import Vue from 'vue'
import axios from '@/http-common'

import { CUESTIONARIOS_REQUEST, CUESTIONARIOS_ERROR, CUESTIONARIOS_SUCCESS } from '../actions/cuestionarios'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { 
  status: '', 
  cuestionarios: []
}

const getters = {
  numeroCuestionariosPendientes: state => state.cuestionarios.length,
  hayCuestionariosPendientes: state => state.cuestionarios.length > 0
}

const actions = {
  [CUESTIONARIOS_REQUEST]: ({commit}) => {
    commit(CUESTIONARIOS_REQUEST)
    axios.get('/cuestionarios' , {})
      .then(response => {
        commit(CUESTIONARIOS_SUCCESS, response.data)
      })
      .catch(() => {
        commit(CUESTIONARIOS_ERROR)
      })
  }
}

const mutations = {
  [CUESTIONARIOS_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [CUESTIONARIOS_SUCCESS]: (state, resp) => {
    state.status = 'success'
    
    Vue.set(state, 'cuestionarios', resp)
  },
  [CUESTIONARIOS_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.cuestionarios = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
